export const isFileHidden = (name: string) => name.startsWith('.');
